<template>
  <div class="caution-area">
    <div v-if="cautionMessage" class="d-flex align-items-center caution mb-2">
      <FeatherIcon icon="alert-triangle" size="24" />
      <div class="ml-1">
        {{ cautionMessage }}
      </div>
    </div>
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

@Component({
  components: {
    FeatherIcon
  }
})
export default class CautionArea extends Vue {
  @Prop({
    type: String,
    default: ""
  })
  cautionMessage!: string;
}
</script>

<style lang="scss" scoped>
.caution-area {
  padding: 16px;
  font-size: 12px;
  background-color: $primary-bg;
  border: 1px solid $yellow;
  border-radius: 2px;

  .caution {
    font-size: 14px;
    font-weight: 500;
    color: $orange-70;
  }
}
</style>
